{
  "404": {
    "title": "This page went fishing.",
    "text": "If you believe this is an error, send us a message at ",
    "back_button": "Return to Dashboard"
  },
  "auth": {
    "promo_eyebrow": "Professional proxy infrastructure",
    "promo_title": "Everything you need to manage proxy access.",
    "promo_description": "Usage analytics, credentials, billing and your team — in one secure dashboard.",
    "toggle_theme": "Toggle color theme",
    "email_or_username": "Email or username",
    "login_description": "Sign in to manage your proxies and account.",
    "signing_in": "Signing in…",
    "login_failed": "The email or password is incorrect.",
    "google_failed": "Google sign-in failed. Please try again.",
    "signup_title": "Create your account",
    "signup_description": "Start managing proxy access in a few moments.",
    "password_hint": "At least 8 characters",
    "password_minimum": "Password must contain at least 8 characters.",
    "passwords_mismatch": "Passwords do not match.",
    "referral_code": "Referral code",
    "optional": "Optional",
    "creating_account": "Creating account…",
    "signup_failed": "Account creation failed. Please try again.",
    "security_required": "Complete the security check.",
    "security_failed": "Security verification failed. Please try again.",
    "security_expired": "Security verification expired. Please verify again.",
    "recovery_description": "We will send a secure reset link to your email.",
    "recovery_sent": "If the account exists, recovery instructions were sent to {email}.",
    "sending": "Sending…",
    "recovery_failed": "Unable to send recovery instructions. Please try again.",
    "updating_password": "Updating password…",
    "reset_failed": "The reset link is invalid or expired."
  },
  "login": {
    "instructions_title": "How it works:",
    "instructions": "We'll send a secure link to your email address. Click the link to create a new password for your account.",
    "or": "Or",
    "agree": "I agree with",
    "createAccount": "Create Account",
    "createNewAccount": "Create a New Account",
    "login": "Log In",
    "password": "Password",
    "password_confirmation": "Password Confirmation",
    "recover_password": "Recover Password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Stay logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset Password",
    "welcome_back": "Welcome back!",
    "forgot_password": "Forgot password?",
    "dont_have_account": "Don't have an account?",
    "login_with_discord": "Log in with Discord",
    "login_with_google": "Log in with Google",
    "back_to_login": "Back to Login"
  },
  "signup": {
    "already_have_account": "Already have an account?",
    "email_exists": "Email already exists.",
    "token_invalid": "Token is invalid.",
    "password_invalid": "Password is invalid.",
    "token_not_set": "Token is not set. Contact support."
  },
  "recover_password": {
    "email_sent_title": "Check your email",
    "recovery_email_sent": "We've sent password reset instructions to your email address. Please check your inbox and follow the link to reset your password.",
    "didnt_receive_title": "Didn't receive the email?",
    "check_spam": "Check your spam folder or try sending another email below.",
    "send_recovery_email": "Send Recovery Email",
    "recover_password": "Recover Password",
    "send_another_email": "Send Another Email"
  },
  "reset_password": {
    "reset_password": "Reset Password",
    "password_reset_success_title": "Password Reset Successfully",
    "password_reset_success_message": "Your password has been successfully reset. You can now log in with your new password.",
    "go_to_login": "Go to Login",
    "instructions_title": "Create New Password",
    "instructions": "Please enter your new password. Make sure it's strong and secure.",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    "enter_new_password": "Enter your new password",
    "confirm_new_password": "Confirm your new password",
    "password_requirements_title": "Password Requirements",
    "min_8_chars": "At least 8 characters long",
    "not_too_common": "Not a commonly used password",
    "not_similar_to_personal": "Not too similar to your personal information",
    "not_entirely_numeric": "Cannot be entirely numeric"
  },
  "home": {
    "no_active_plans": "No active plans",
    "no_active_plans_description": "You currently don't have any active plans. To start using proxies, please order a plan first.",
    "whitelist_placeholder": "Enter one IP address per line...",
    "blacklisted_domains_placeholder": "Enter one domain per line...",
    "view_all_domains": "View all domains",
    "domains_analytics_subtitle": "Analyze proxy requests by domain over time.",
    "data_usage_subtitle": "Track your data consumption across packages.",
    "feed_analytics_subtitle": "View recent proxy requests in real-time.",
    "usage_statistics_subtitle": "Monitor your proxy usage and data consumption over time.",
    "proxy_credentials_title": "Proxy access credentials",
    "proxy_credentials_description": "Use these ready-to-go credentials in your tools, scripts, and browsers.",
    "proxy_format_description": "Choose how you want the proxy string to look.",
    "gateway": "Gateway",
    "gateway_unavailable": "Gateways are not available at the moment. Credentials below may be incomplete.",
    "http_credentials_hint": "Use this line in browsers, curl, Scrapy, and most HTTP-based tools.",
    "socks5_credentials_hint": "Use this line in tools that support SOCKS5 proxies.",
    "total_items": "Total Items",
    "data_allocation": "Data Allocation",
    "invalid_ips": "Invalid IPs",
    "invalid_domains": "Invalid Domains",
    "sticky_description": "Maintain same IP for duration",
    "rotating_description": "Change IP on each request",
    "http_description": "Standard web protocol",
    "socks5_description": "Advanced proxy protocol",
    "auto_description": "Automatic protocol detection",
    "generated_proxies": "Generated Proxies",
    "domain_examples": "Domain Examples",
    "exact_domains": "Exact Domains",
    "wildcard_domains": "Wildcard Domains",
    "ip_examples": "IP Examples",
    "ipv4_examples": "IPv4 Examples",
    "ipv6_examples": "IPv6 Examples",
    "show_examples": "Show Examples",
    "hide_examples": "Hide Examples",
    "valid_ips": "Valid IPs",
    "valid_domains": "Valid Domains",
    "location_targeting": "Location Targeting",
    "consumed_data": "Consumed Data",
    "remaining_data": "Remaining Data",
    "remaining": "Remaining",
    "total_data": "Total Data",
    "auto_renewal_description": "If auto renewal is enabled, each package will be automatically renewed from your wallet fund when data usage goes below the set percentage.",
    "filter_domain": "Filter by Domain",
    "export_csv": "Export as CSV",
    "subscription_enabled": "Subscription enabled",
    "subscription_disabled": "Subscription disabled",
    "subscription_disabled_message": "You have successfully disabled auto-renewal for {name}",
    "subscription_enabled_message": "You have successfully enabled auto-renewal for {name}",
    "subscription_settings": "Subscription Settings",
    "data_left": "Data Left",
    "data_spent": "Data Spent",
    "renewal_threshold": "Renewal Threshold",
    "topup_amount": "Top Up Amount",
    "data_usage": "Data Usage",
    "auto_renew": "Auto Renewal",
    "reward_pending": "reward pending",
    "reward_earned": "reward earned",
    "spent": "spent",
    "available": "available",
    "loading_chart": "Loading chart...",
    "company_name": "Company Name",
    "postal_code": "ZIP Code",
    "vat_number": "VAT Number",
    "gateways": "Gateways",
    "gateway_description": "Select the gateway/hostname you want to use.",
    "location": "Location",
    "feed_analytics": "Recent Requests",
    "overall_analytics": "Overall Analytics",
    "domains_analytics": "Domain Analytics",
    "welcome": "Welcome",
    "add": "Add",
    "used": "Used",
    "left": "Left",
    "active_plans": "Active Plans",
    "balance": "Balance",
    "loyalty_tier": "Loyalty Level",
    "reseller_account": "Reseller Account",
    "reseller_request": "Request reseller account by contacting support.",
    "referrals": "Referrals",
    "proxy_plans": "Proxy Plans",
    "proxy_generator": "Proxy Generator",
    "proxy_generator_subtitle": "Generate proxy access credentials for your packages.",
    "proxy_credentials": "Proxy Credentials",
    "plan": "Plan",
    "protocol": "Protocol",
    "session": "Session",
    "format": "Format",
    "address": "Address",
    "duration": "Duration",
    "host": "Host",
    "port": "Port",
    "user": "User",
    "blacklisted_domains": "Blacklisted Domains",
    "blacklisted_domains_subtitle": "Restrict access to specific domains through your proxies.",
    "blacklisted_domains_description": "Your proxy services will block access to all domains listed below. Each domain should be entered on a new line. To block a specific domain only, enter it directly (e.g., google.com). To block a domain and all its subdomains, use the wildcard format (e.g., *.google.com). If the list is empty, no domains will be restricted and all websites will be accessible through your proxies.",
    "ip_whitelisting": "IP Whitelist",
    "ip_whitelisting_subtitle": "Restrict proxy access to specific IP addresses.",
    "ip_whitelisting_description": "Your proxy services can only be accessed from the IP addresses listed below. Each IP should be entered on a new line.\n            If no IPs are specified, your account services will be accessible from any IP address.\n            This whitelist serves as an additional security measure to protect your account from unauthorized access.",
    "download_txt": "Download .txt",
    "usage_statistics": "Usage Statistics",
    "bandwidth": "Bandwidth",
    "hostname": "Domain",
    "requests": "Requests",
    "expired": "Expired",
    "filter": "Filter",
    "no_data_available": "No data available",
    "no_data_description": "No matching data for your current selection criteria.",
    "no_matching_records": "No matching records found",
    "no_matching_domains": "No matching domains found",
    "try_different_search": "Try a different search or filter criteria.",
    "sticky": "Sticky",
    "rotating": "Rotating",
    "no_packages": "No packages",
    "continent_targeting_notice": "When continent targeting is selected, country, region and city targeting are not available.",
    "whitelist": {
      "invalid_ip_error": "One or more IP addresses are invalid. Each line should contain a valid IPv4 or IPv6 address."
    },
    "blacklist": {
      "invalid_domain_error": "One or more domains are invalid. Each line should contain a valid domain (e.g., example.com or *.example.com)."
    },
    "reset_changes": "Reset changes",
    "reset_to_original": "Restore saved values",
    "no_active_subscriptions": "No active subscriptions",
    "domain": "Domain",
    "auto": "Auto"
  },
  "balance": {
    "buy_proxies_title": "Buy Proxies",
    "buy_proxies_subtitle": "Purchase proxy packages using your account balance.",
    "no_invoices_description": "No invoices found. Add balance to your account to bypass payment waiting times and enjoy hassle-free checkout.",
    "invoices_title": "Invoices",
    "invoices_subtitle": "Manage your invoices and payments.",
    "loading_invoices": "Loading invoices...",
    "no_coupon": "No Coupon",
    "payment_status": "Payment Status",
    "you_saved": "You saved",
    "review": "Review",
    "cancelled": "Cancelled",
    "failed": "Failed",
    "invoice": "Invoice",
    "title": "Balance",
    "current_balance": "Current Balance",
    "pending_balance": "Pending Balance",
    "total_balance": "Total Balance",
    "top_up": "Top Up",
    "payment_method": "Payment Method",
    "crypto": "Cryptocurrency",
    "coupon": "Coupon",
    "company": "Company",
    "stripe": "Stripe",
    "add_balance": "Add Balance",
    "recent_orders": "Recent Orders",
    "invoice_id": "Invoice ID",
    "payment": "Payment",
    "product": "Product",
    "usage": "Usage",
    "download": "Download",
    "pay": "Pay",
    "delete": "Delete",
    "no_invoices": "No invoices found",
    "free_data": "Free Data",
    "view": "View",
    "view_balance": "View your balance or top it up with our flexible payment options.",
    "bypass_payment": "Bypass payment waiting times. Hassle-free checkout. Balance does not expire.",
    "confirm_delete_message": "Are you sure you want to delete this invoice?",
    "confirm_delete_title": "Delete Invoice",
    "confirm_delete_subtitle": "Delete this invoice",
    "confirm_delete_warning": "This action cannot be undone.",
    "one_time": "One-time",
    "payout": "Payout",
    "balance_top_up": "Balance top-up",
    "payment_link": "Payment link",
    "pay_now": "Pay now",
    "saved": "Saved"
  },
  "loyalty_rewards": {
    "points": "Points",
    "benefits": "Benefits",
    "title": "Loyalty Rewards",
    "tiers": "Loyalty Tiers",
    "description": "Earn (1) point for every dollar spent. Be rewarded for your loyalty!",
    "loyalty_points": "Loyalty Points",
    "balance_spent": "Balance Spent",
    "points_earned": "Points Earned",
    "total_points": "Total Points",
    "rank": "Rank",
    "no_rewards": "No rewards found"
  },
  "referrals": {
    "no_earnings_yet": "No earnings yet",
    "no_earnings_description": "You haven't earned any rewards yet. Share your referral link to start earning!",
    "overall": "Overall",
    "share_link_hint": "Share your unique referral link to invite friends and earn rewards.",
    "no_referrals_yet": "No referrals yet",
    "no_referrals_description": "You haven't referred any users yet. Share your referral link to start earning rewards!",
    "payout_details": "Payout Details",
    "payout_details_placeholder": "Please provide details about where you want to receive your payout (e.g., PayPal email, bank account details, cryptocurrency wallet address, etc.)",
    "payout_details_help": "Specify your preferred payment method and the necessary details for processing your reward payout.",
    "payout_details_required": "Payout details are required for balance claims.",
    "no_orders_yet": "No orders yet",
    "no_orders_description": "You haven't made any orders yet. Start earning rewards by referring friends!",
    "commission_structure": "Commission Structure",
    "awaiting_payout": "Awaiting Payout",
    "all_time": "All Time",
    "performance_analytics": "Performance Analytics",
    "performance_analytics_subtitle": "Track your referral performance over time.",
    "payout": "Payout",
    "marketer_dashboard": "Marketer Dashboard",
    "marketer_dashboard_subtitle": "Manage your referral program and track earnings.",
    "client_orders": "Client Orders",
    "package_earnings": "Package Earnings",
    "ordered_package": "Ordered Package",
    "confirm_claim_payout": "Claim Payout",
    "data_bonus": "Data Bonus",
    "money_bonus": "Money Bonus",
    "referral_link": "Referral Link",
    "claim_payout": "Claim Payout",
    "claim_bonus_traffic": "Claim bonus traffic",
    "available_claim": "Available to claim",
    "all_time_earned": "All-time earned",
    "share_referral_link": "Share referral link",
    "get_reward": "Get Reward",
    "how_it_works": "How it works",
    "referral_program": "Referral Program",
    "my_bonuses": "My Bonuses",
    "my_bonuses_subtitle": "Track and claim your earned bonus traffic.",
    "bonus_amount": "Bonus Amount",
    "not_enough_data": "Not enough data to claim.",
    "no_pending_rewards": "No pending rewards",
    "reward_claimed": "Reward successfully claimed.",
    "invite_friends": "Invite Friends & Earn Bonus Traffic!",
    "invite_friends_description": "Get 15% bonus traffic when your friend makes their first order (excluding trials)",
    "copy_link_description": "Copy your unique link and send it to your friends",
    "get_reward_description": "Both you and your friends get 15% bonus traffic of their first order",
    "claim_bonus_traffic_description": "Claim your bonus traffic into usable data anytime! Transferred amount will be added to \"traffic left\"",
    "confirm_claim_title": "Claim Bonus Traffic: {amount}",
    "confirm_claim_message": "You are about to claim your pending bonus traffic. Once submitted, your claim will be processed by our administration team.",
    "claim_review_notice": "The status of your pending rewards will be updated, and our team will review your claim. Your bonus traffic will be credited to your account as soon as possible after verification.",
    "proceed_with_claim": "Proceed with Claim"
  },
  "buy_proxies": {
    "countries": "Countries",
    "connections": "Connections",
    "usage_based": "Usage-Based Pricing",
    "tiered_plan": "Tiered Plan",
    "coupons_available": "Coupons Available",
    "final_price": "Final Price",
    "coupon_discount_applied": "Coupon Discount Applied",
    "original_price": "Original Price",
    "discount": "Discount",
    "total": "Total",
    "select_cryptocurrency": "Select Cryptocurrency",
    "selected_cryptocurrency": "Selected Cryptocurrency",
    "coupon_active": "Coupon Active",
    "discount_will_apply": "Discount will be applied at checkout",
    "remove_coupon": "Remove coupon",
    "estimated_savings": "Estimated savings",
    "have_coupon": "Have a coupon code?",
    "or_select_available": "Or select from your available coupons",
    "coupon_applied_success": "Coupon {code} applied successfully!",
    "available_coupons": "Available Coupons",
    "apply_coupon_savings": "Click any coupon below to apply savings to all packages",
    "coupon_percentage_desc": "Get {value}% off your order",
    "coupon_monetary_desc": "Save {currency}{value} on your order",
    "apply_to_all_packages": "Apply to All",
    "coupon_applied": "Coupon Applied",
    "coupon_applied_all": "Coupon {code} applied to all packages",
    "coupon_info": "Coupons can be combined with any payment method and will be applied at checkout",
    "billing_cycle": "Data will be available for {cycle} days",
    "one_time_order_warning_title": "⚠️ One-Time Order Only",
    "one_time_order_warning_message": "This package can only be orderd once per account. Please ensure you select the right amount as this order cannot be repeated.",
    "one_time_no_renewal": "No automatic renewal or subscription",
    "one_time_single_order": "Can only be orderd once per account",
    "one_time_data_consumed": "Data/proxies consumed permanently after use",
    "one_time_consider_carefully": "⚡ Choose wisely - this offer won't be available again",
    "one_time_order": "One-time Order",
    "wallet": "Wallet",
    "select_data_amount": "Select Data Amount",
    "current_price": "Current Price",
    "per_gb": "per GB",
    "per_package": "per package",
    "datacenter": "Datacenter",
    "residential": "Residential",
    "ipv6": "IPv6",
    "most_popular": "Most Popular",
    "standard": "Standard",
    "premium": "Premium",
    "bandwidth": "Bandwidth",
    "duration": "Duration",
    "threads": "Threads",
    "search_domain": "Enter your domain here...",
    "check": "Check",
    "check_ipv6_support": "Check IPv6 Support",
    "features_locations": "60+ Locations",
    "features_unlimited_threads": "Unlimited Threads",
    "features_rotating": "IP Change with Every Request",
    "features_country_targeting": "Country Targeting",
    "features_sticky_sessions": "Sticky IP Sessions",
    "features_user_pass_auth": "Username/Password Authentication",
    "features_unlimited_bandwidth": "Unlimited Bandwidth",
    "features_usa_regions": "USA Regions",
    "get_started": "Get Started",
    "order": "Order",
    "add_coupon": "Apply Coupon",
    "hide_coupon": "Hide Coupon",
    "enter_coupon": "Enter your coupon code...",
    "add_company_info": "Add Company",
    "hide_company_info": "Hide Company",
    "enter_company_name": "Enter your company name...",
    "vat_number": "VAT Number",
    "vat_applies": "VAT will automatically be applied to price and invoice.",
    "payment_method": "Payment Method",
    "credit_card": "Credit Card",
    "crypto": "Crypto",
    "for": "for",
    "company_name": "Company Name",
    "country_code": "Country Code",
    "enter_company_vat": "Enter your VAT number...",
    "enter_company_country": "Enter country code (e.g., US, GB, DE)",
    "note": "*Note: Standard and premium proxies are supplied differently, thus performance and speed may vary."
  },
  "dashboard": {
    "title": "Dashboard",
    "title_subtitle": "Welcome back! Here's your proxy usage overview.",
    "versions": "Versions",
    "setupRemoteConnections": "Set Up Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "Navigation Layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Sidebar"
  },
  "menu": {
    "404": "404",
    "sub_users": "Sub-Users",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "reseller": "Reseller",
    "add_funds": "Add Funds",
    "wallet": "Wallet",
    "home": "Home",
    "language": "Language",
    "powered_by": "Powered by",
    "buy_proxies": "Buy Proxies",
    "balance": "Balance",
    "loyalty_rewards": "Loyalty Rewards",
    "referrals": "Referrals",
    "marketer": "Marketer",
    "account": "Account",
    "support": "Support",
    "contact": "Contact",
    "blog": "Blog",
    "dark_mode": "Dark Mode",
    "logout": "Log Out",
    "inventory": "Inventory",
    "tos": "Terms of Service",
    "policy": "Privacy Policy",
    "policy_subtitle": "Learn how we handle your data",
    "developer": "Developer",
    "auth": "Authorization",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Log In",
    "preferences": "Account Settings",
    "payments": "Payments",
    "signup": "Sign Up",
    "recover_password": "Recover Password",
    "recover_password_email": "Password Recovery Email",
    "projects": "Projects",
    "all_systems_operational": "All Systems Operational",
    "api_docs": "API Documentation",
    "docs": "Documentation"
  },
  "documentation": {
    "description": "Download comprehensive PDF documentation for different packages and services.",
    "package_description": "Complete guide for basic integration and usage",
    "available_packages": "Available Packages",
    "no_packages_available": "No packages available",
    "no_packages_description": "No documentation available for download at the moment. Order a package to access its documentation."
  },
  "account": {
    "webhooks": "Webhooks",
    "webhooks_description": "Manage your webhooks for real-time notifications.",
    "create_webhook": "Create Webhook",
    "create_webhook_hint": "Set up a new webhook to receive real-time notifications about account events.",
    "webhook_endpoint": "Webhook Endpoint",
    "webhook_endpoint_note": "Enter the URL where you want to receive webhook notifications.",
    "webhook_type_note": "Reseller Events include your events and those of your sub-users. User Events include only your own events.",
    "read_timeout": "Read Timeout (seconds)",
    "write_timeout": "Write Timeout (seconds)",
    "retries": "Retries",
    "retry_timeout": "Retry Timeout (seconds)",
    "your_webhooks": "Your Webhooks",
    "your_webhooks_hint": "Manage your existing webhooks and their configurations.",
    "no_webhooks": "No webhooks found",
    "no_webhooks_hint": "Create webhooks to receive real-time notifications about account events.",
    "webhook_type_user": "User Events",
    "webhook_type_reseller": "Reseller Events",
    "webhook_type_system": "System Events",
    "webhook_created": "Webhook created successfully.",
    "webhook_secret": "Webhook Secret",
    "secret_hidden": "Secret is hidden.",
    "secret_hidden_hint": "Click the eye icon to reveal the secret.",
    "webhook_secret_hint": "Keep this secret safe. It will be used to verify the authenticity of incoming webhook requests.",
    "two_factor_off": "2FA disabled",
    "invalid_otp": "Invalid authentication code. Please try again.",
    "scan_qr": "Scan the QR code",
    "confirm_and_enable": "Confirm and Enable",
    "manual_key": "Manual Key Entry",
    "manual_key_help": "Enter the secret key provided below into your authentication app.",
    "secret_key": "Secret Key",
    "otpauth_url": "URL for OTP Auth",
    "enter_6_digit_code": "Enter the 6-digit code from your authentication app",
    "confirm_code_help": "Open your authentication app and enter the 6-digit code generated for this account.",
    "qr_note_google_auth": "Use an authentication app like Google Authenticator, Authy, or any other TOTP-compatible app to scan the QR code.",
    "setup_2fa": "Set Up Two-Factor Authentication",
    "setup_2fa_description": "Enhance your account security by enabling two-factor authentication (2FA).",
    "qr_will_appear_here": "QR code will appear here",
    "two_factor_auth": "Two-Factor Authentication",
    "two_factor_auth_description": "Add an extra layer of security to your account by enabling two-factor authentication (2FA).",
    "enable_2fa": "Enable Two-Factor Authentication",
    "two_factor_hint": "Enhance your account security by enabling two-factor authentication (2FA).",
    "delete_warning_title": "Are you sure you want to delete your account?",
    "delete_warning_text": "This action is irreversible. All your data, settings, and account information will be permanently deleted. Please ensure you have backed up any important information before proceeding.",
    "type_delete": "Type 'DELETE' to confirm",
    "type_delete_exact": "To confirm, please type the word 'DELETE' in uppercase letters in the field below.",
    "delete_ack": "By typing 'DELETE', you acknowledge that you understand the consequences of this action and wish to proceed with deleting your account.",
    "current_password": "Current Password",
    "new_password": "New Password",
    "repeat_new_password": "Repeat New Password",
    "change_password": "Change Password",
    "change_password_description": "Update your account password regularly to enhance security.",
    "create_api_key": "Create API Key",
    "api_auth_usage_title": "API Authentication Usage",
    "api_key": "API Key",
    "no_api_keys": "No API keys found",
    "no_api_keys_hint": "You haven't created any API keys yet. API keys allow you to programmatically access your account and perform various actions using our API.",
    "api_keys_description": "Manage your API keys for programmatic access to your account.",
    "password_last_changed": "Password last changed",
    "days_ago": "{days} days ago",
    "vat_optional": "VAT Number (optional)",
    "phone_number": "Phone Number",
    "member_since": "Member since",
    "danger_zone": "Danger Zone",
    "danger_zone_description": "These actions are irreversible. Please proceed with caution.",
    "delete_account": "Delete Account",
    "delete_account_description": "Permanently delete your account and all associated data.",
    "profile_information": "Profile Information",
    "profile_information_description": "Update your account's profile information and email address.",
    "company_information": "Company Information",
    "company_information_description": "Update your company's profile information for billing purposes.",
    "security_settings": "Security Settings",
    "security_settings_description": "Update your account password and security settings.",
    "notification_preferences": "Notification Preferences",
    "notification_preferences_description": "Manage your email notification preferences.",
    "expiry_reminders": "Expiry Reminders",
    "expiry_reminders_description": "Receive reminders before your packages expire.",
    "security_alerts": "Security Alerts",
    "security_alerts_description": "Get alerted about suspicious account activities.",
    "marketing_updates": "Marketing Updates",
    "marketing_updates_description": "Receive updates about new features, promotions, and offers.",
    "two_factor": "Two-Factor Authentication",
    "using_auth_app": "Using an authentication app",
    "api_keys": "API Keys",
    "active_keys": "Active Keys",
    "manage_api_keys": "Manage your API keys.",
    "manage_profile_description": "Manage your account profile and settings.",
    "access_control": "Access Control",
    "access_control_description": "Manage access permissions for your account.",
    "credentials": "Credentials",
    "credentials_description": "Manage your access credentials.",
    "personal_info_description": "Update personal information.",
    "company_info_description": "Update company information for billing purposes.",
    "location_description": "Update location information.",
    "language": "Change Language",
    "logout": "Log Out",
    "billing": "Billing",
    "helpAndSupport": "Help & Support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore",
    "save_profile": "Save Profile",
    "personal_info": "Personal Information",
    "location": "Location",
    "first_name": "First Name",
    "last_name": "Last Name",
    "telegram": {
      "title": "Telegram Dashboard",
      "description": "Check traffic, proxies, billing and account settings directly in Telegram.",
      "loading": "Loading Telegram connection…",
      "unavailable": "Telegram Dashboard is not available for this deployment.",
      "status_disconnected": "Not connected",
      "status_pending": "Waiting for confirmation",
      "status_connected": "Connected",
      "connected_account": "Telegram account connected",
      "linked_at": "Connected {date}",
      "pending_title": "Open the bot and confirm this account",
      "expires_in": "The secure link expires in {time}.",
      "disconnected_title": "Use your dashboard from Telegram",
      "disconnected_description": "A private, single-use link connects your current account.",
      "language": "Bot language",
      "connect": "Connect Telegram",
      "new_link": "Create a new link",
      "continue_in_telegram": "Continue in Telegram",
      "open": "Open bot",
      "disconnect": "Disconnect",
      "disconnect_confirm": "Disconnect this Telegram account? Existing bot access will stop immediately.",
      "load_failed": "Unable to load the Telegram connection.",
      "link_failed": "Unable to create a Telegram link.",
      "update_failed": "Unable to update Telegram settings.",
      "disconnect_failed": "Unable to disconnect Telegram.",
      "language_updated": "Telegram language updated.",
      "disconnected": "Telegram disconnected."
    },
    "social": {
      "title": "Social accounts",
      "description": "Connect Google to use it as an additional sign-in method.",
      "connect": "Connect Google",
      "linked": "Connected",
      "notLinked": "Not connected",
      "passwordHint": "Confirm your current password, then choose your Google account.",
      "password": "Current password",
      "connecting": "Connecting…",
      "success": "Google is now connected.",
      "error": "Unable to connect Google. Please try again.",
      "loadError": "Unable to load social accounts.",
      "passwordRequired": "Enter your current password.",
      "retry": "Retry"
    },
    "disable_2fa": "Disable two-factor authentication",
    "disable_2fa_description": "Enter a code from your authentication app to disable two-factor authentication.",
    "two_factor_enabled_success": "Two-factor authentication enabled.",
    "two_factor_disabled_success": "Two-factor authentication disabled.",
    "webhook_advanced_note": "Adjust timeouts and retries for your endpoint.",
    "invalid_webhook_endpoint": "Enter a valid HTTP or HTTPS URL.",
    "webhook_created_toast": "Webhook created.",
    "webhook_deleted_toast": "Webhook deleted.",
    "api_key_created": "API key created",
    "api_key_created_hint": "Copy it now — it is only shown once.",
    "last_used": "Last used",
    "api_token_not_available": "Token unavailable. Create a new API key if needed.",
    "account_type": "Account type"
  },
  "reseller": {
    "users_subtitle": "Manage users under your reseller account.",
    "update_package": "Update Package",
    "proxy_password_description": "Update the authentication password for this user's proxy access.",
    "allowed_range": "Allowed Range",
    "package_type": "Package Type",
    "package_type_description": "Package type cannot be changed after creation. To use a different package, create a new assignment.",
    "edit_package_assignment": "Edit Package Assignment",
    "edit_package_assignment_description": "Update data allocation and proxy settings",
    "assigned_to": "Assigned to",
    "assign_package": "Assign Package",
    "assign_package_success": "Package has been assigned successfully.",
    "update_package_success": "Package has been updated successfully.",
    "assigning_package_to": "Assigning package to",
    "assign_package_description": "Update package details and configuration",
    "select_package": "Select Package",
    "choose_package": "Choose a package",
    "user_created_successfully": "User created successfully.",
    "no_packages_assigned": "No packages assigned",
    "no_packages_assigned_subtitle": "Assign proxy packages to this user.",
    "overcommit_mode": "Overcommit Mode",
    "overcommit_banner": "This order does not use per-order data ledgers. All traffic consumed by this user is deducted directly from the parent package balance.",
    "add_data": "Add Data",
    "total_users": "Total Users",
    "manage_user_orders": "Manage user orders.",
    "edit_user_description": "Edit user information.",
    "all_users": "All Users",
    "confirm_delete_order_title": "Delete Order",
    "confirm_delete_order_message": "Are you sure you want to delete this order?",
    "confirm_delete_title": "Delete User",
    "confirm_delete_message": "Are you sure you want to delete this user and all of his orders?",
    "manage_orders": "Manage Orders",
    "create_order": "Create Order",
    "no_orders": "No orders",
    "no_users_available": "No users available",
    "no_users_description": "No users available for this reseller.",
    "no_usage": "No usage",
    "latest_use": "Latest Use",
    "create_user": "Create User",
    "create_user_description": "Create a new user under your account.",
    "edit_user": "Edit User",
    "user_orders": "User Orders",
    "subusers_list": "Users List",
    "manage_subusers": "Manage users"
  },
  "errors": {
    "buy_proxies": {
      "failed_to_create_invoice": "Failed to create invoice. Contact support or try again later.",
      "code_not_available_for_one_time": "Code not available for one-time order packages.",
      "code_only_for_marketers": "This coupon code is only available for users invited by marketers.",
      "one_time_order_already_exists": "You already have a invoice for one-time order. Please pay it or delete it before creating a new one.",
      "one_time_order_not_allowed": "One-time order is not allowed. You already orderd it.",
      "invoice_created": "Invoice Created. Redirecting to Payment Page...",
      "invoice_failed": "Failed to create invoice. Please try again later.",
      "invalid_coupon": "Invalid coupon code.",
      "already_redeemed_coupon": "Coupon code has already been redeemed.",
      "expired_coupon": "Coupon code has expired.",
      "code_not_available_for_package": "Code not available for this package.",
      "code_not_available_for_user": "Code not available for this user.",
      "balance_topup_not_allowed": "Balance top up is not allowed for balance type",
      "quantity_required_for_package": "Quantity is required for this package.",
      "data_required_for_package": "Data is required for this package.",
      "not_enough_balance": "Not enough balance to order this package.",
      "user_required": "User is required.",
      "package_not_found": "Package not found.",
      "package_required": "Package is required.",
      "country_not_found": "Country not found.",
      "user_not_found": "User not found.",
      "payment_gateways_not_set": "Payment gateways not set.",
      "failed_to_create_cryptomus_invoice": "Failed to create Cryptomus invoice.",
      "failed_to_create_coinbase_charge": "Failed to create Coinbase charge.",
      "failed_to_create_stripe_session": "Failed to create Stripe session.",
      "data_out_of_range": "Data is out of range. Make sure it is within the allowed package range.",
      "invalid_billing_model": "Invalid billing model. It's internal error, please contact support.",
      "not_enough_proxies": "Not enough proxies available for this package. Change the amount or contact support.",
      "country_required_for_company": "Country is required when company data is provided.",
      "too_many_pending_invoices": "User has too many pending invoices. Please pay or delete them before creating a new one.",
      "user_required_for_paid_invoices": "User is required for paid invoices and is only available for reseller accounts.",
      "only_allowed_for_resellers": "Only resellers can create invoices for other users.",
      "system_miss_configured": "The system is misconfigured. Please contact support.",
      "calculate_invoice_price": "Failed to calculate invoice price.",
      "coupon_limits_reached": "Number of users who can use this coupon has been reached."
    },
    "analytics": {
      "export_success": "Exported successfully.",
      "export_failed": "Failed to export.",
      "overall_loaded": "Overall analytics loaded.",
      "overall_failed": "Failed to load overall analytics.",
      "feed_loaded": "Requests feed loaded.",
      "feed_failed": "Failed to load requests feed.",
      "domains_loaded": "Domain analytics loaded.",
      "domains_failed": "Failed to load domain analytics.",
      "locations_failed": "Failed to load locations.",
      "settings_failed": "Failed to load settings.",
      "end_data_should_be_greater": "End date should be greater than start date.",
      "date_range_too_large": "Date range is too large. Please select a smaller range.",
      "invalid_limit": "Invalid limit.",
      "only_available_to_superuser": "This feature is only available to superusers.",
      "only_available_to_resellers": "This feature is only available to resellers.",
      "can_only_filter_by_own_user_id": "You can only filter by your own user ID.",
      "can_only_filter_by_reseller_id": "You can only filter by reseller ID.",
      "can_only_filter_by_own_sub_users": "You can only filter by your own sub-users.",
      "at_least_one_id_required": "At least one of package_id, reseller_id or user_id should be provided.",
      "invalid_package_id": "Invalid package_id must be a valid UUIDv4.",
      "invalid_reseller_id": "Invalid reseller_id must be a valid UUIDv4.",
      "invalid_user_id": "Invalid user_id must be a valid UUIDv4.",
      "invalid_country_code": "Invalid country code.",
      "country_required_for_region_filter": "Country is required when filtering by region.",
      "city_required_for_region_filter": "City is required when filtering by region and/or country.",
      "invalid_region_name_format": "Invalid region name format.",
      "invalid_city_name_format": "Invalid city name format.",
      "invalid_proxy_protocol": "Invalid protocol must be one of the following: http, socks5."
    },
    "proxy": {
      "copied": "Proxies copied to clipboard.",
      "generated": "Proxies generated.",
      "small_quantity": "Small quantity of proxies. Make sure to provide number greater than 0.",
      "package_not_found": "Package not found.",
      "package_required": "Package is required.",
      "user_not_found": "User not found."
    },
    "whitelist": {
      "updated": "IP whitelist updated."
    },
    "blacklist": {
      "updated": "Blacklist updated."
    },
    "profile": {
      "updated": "Profile updated.",
      "one_field_required": "At least one field is required.",
      "email_exists": "Email already exists.",
      "too_many_allowed_ips": "Too many allowed IPs",
      "field_can_be_edited_by_reseller_only": "This field can only be edited by the reseller.",
      "invalid_new_password": "New password is invalid.",
      "missing_any_package": "User must have at least one package.",
      "max_subusers": "Max sub-users reached.",
      "only_resellers_can_create_users": "Only resellers can create users.",
      "order_not_found": "Order not found.",
      "insufficient_residential_data": "Not enough residential data available.",
      "insufficient_balance": "Insufficient balance.",
      "old_password_required": "Old password is required to change the password.",
      "invalid_old_password": "Old password is invalid.",
      "invalid_new_password_format": "Invalid password format, make sure it contains only letters, numbers, and underscores",
      "not_enough_data": "Not enough data available.",
      "user_not_found": "User not found."
    },
    "package": {
      "cant_manage_status_of_deactivated_user": "You can't manage the status of a deactivated user.",
      "cant_toggle_status_of_deactivated_user": "You can't toggle the status of a deactivated user.",
      "cant_toggle_active_status_of_deactivated_user": "You can't toggle the active status of a deactivated user.",
      "package_not_found": "Package not found.",
      "package_not_found_for_user": "Package not found for user.",
      "multiple_packages_found": "Multiple packages found for user.",
      "reset_password_too_frequent": "You are trying to reset the password too frequently. Please wait a few minutes before trying again.",
      "failed_to_create_order": "Failed to create new user order."
    },
    "invoices": {
      "download_failed": "Failed to download invoice.",
      "load_payment_url_failed": "Failed to load payment URL.",
      "delete_success": "Invoice deleted.",
      "delete_failed": "Failed to delete invoice.",
      "invoice_not_pending": "Invoice status is not pending.",
      "invoice_has_error": "Invoice has error and can not be payed.",
      "load_failed": "Failed to load invoices."
    },
    "signup": {
      "email_exists": "Email already exists.",
      "username_exists": "Username already exists.",
      "affiliate_not_found": "Affiliate user not found."
    },
    "reseller": {
      "delete_success": "User deleted.",
      "delete_failed": "Failed to delete user.",
      "assign_package_failed": "Failed to assign package.",
      "update_package_failed": "Failed to update package.",
      "load_users_failed": "Failed to load users.",
      "delete_order_success": "Order deleted.",
      "delete_order_failed": "Failed to delete the order."
    },
    "internal_error": "Internal server error. Please try again later.",
    "password_too_short": "Password is too short.",
    "passwords_do_not_match": "Passwords do not match.",
    "delete_ack_required": "Delete acknowledgment is required.",
    "auth": {
      "social_account_unlinked": "This social account was unlinked. Sign in another way and connect it in account settings."
    },
    "unknown": "Something went wrong. Please try again.",
    "user": {
      "updated": "User updated."
    }
  },
  "wallet": {
    "make_deposit": "Make a Deposit",
    "safe_checkout": "Guaranteed safe & secure checkout",
    "crypto_not_refundable": "Cryptocurrency payments are not refundable. 1% fee applies for this payment method.",
    "complete_deposit": "Complete Deposit",
    "min_amount": "Minimum amount is 20 USD",
    "deposits_never_expire": "Deposits Never Expire",
    "use_anytime": "Use Anytime",
    "no_commitment": "No Commitment",
    "deposit_now": "Deposit Now",
    "deposit_description": "Add funds now. Put them to work whenever you’re ready.",
    "available_balance": "Available balance",
    "choose_method": "Choose a payment method",
    "secure_checkout": "Secure checkout",
    "card_brands": "Pay with Visa, Mastercard, Amex or Discover.",
    "workspace_balance_note": "One balance for your workspace. Use your deposit toward your next proxy purchase.",
    "deposit_amount": "Deposit amount",
    "amount_hint": "Min. $20 · Max. $10,000 · Whole USD amounts",
    "quick_amounts": "Quick deposit amounts",
    "balance_after_deposit": "Balance after deposit",
    "redirecting": "Redirecting to payment…",
    "payment_error": "Unable to start checkout. Please try again."
  },
  "news": {
    "title": "News",
    "subtitle": "Latest updates and announcements from our team.",
    "no_news": "No news available",
    "no_news_description": "There are currently no news or announcements. Please check back later for updates.",
    "announcements": "Announcements",
    "announcements_subtitle": "Latest platform updates and important notices.",
    "product": "Product",
    "maintenance": "Maintenance",
    "security": "Security",
    "billing": "Billing"
  },
  "common": {
    "advanced": "Advanced",
    "advanced_settings": "Advanced Settings",
    "type": "Type",
    "popular": "Popular",
    "renew": "Renew",
    "data_remaining": "Data Remaining",
    "saving": "Saving",
    "refresh": "Refresh",
    "news": "News",
    "expires": "Expires",
    "active": "Active",
    "copy": "Copy",
    "copied": "Copied",
    "change": "Change",
    "manage": "Manage",
    "data": "Data",
    "clear": "Clear",
    "data_updated": "Data updated",
    "current": "Current",
    "proxy_password": "Proxy Password",
    "min": "Min",
    "range": "Range",
    "to": "to",
    "total": "Total",
    "invoices": "Invoices",
    "users": "Users",
    "showing": "Showing",
    "of": "of",
    "creating": "Creating...",
    "loading": "Loading...",
    "loading_invoices": "Loading invoices...",
    "loading_orders": "Loading orders...",
    "loading_users": "Loading users...",
    "search": "Search",
    "reset": "Reset",
    "submit": "Submit",
    "confirm": "Confirm",
    "update": "Update",
    "create": "Create",
    "next": "Next",
    "previous": "Previous",
    "page": "Page",
    "active_consumption": "Active Consumption",
    "created": "Created",
    "ledger": "Ledger",
    "expired": "Expired",
    "expires_in": "Expires in",
    "required_fields": "Required fields",
    "required": "Required",
    "optional": "Optional",
    "allocated": "Allocated",
    "user": "User",
    "active_orders": "Active Orders",
    "never": "Never",
    "last_used": "Last Used",
    "username": "Username",
    "generate": "Generate",
    "updating": "Updating",
    "total_data": "Total Data",
    "download": "Download",
    "customer": "Customer",
    "admin": "Admin",
    "marketer": "Marketer",
    "reseller": "Reseller",
    "no_commission": "No Commission",
    "data_amount": "Data Amount",
    "price": "Price",
    "range_pricing": "Range Pricing",
    "fixed_pricing": "Fixed Pricing",
    "action": "Action",
    "earnings": "Earnings",
    "error": "Error",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "pending": "Pending",
    "review": "Review",
    "total_orders": "Total Orders",
    "total_earnings": "Total Earnings",
    "commission_rate": "Commission Rate",
    "continent": "Continent",
    "country": "Country",
    "region": "Region",
    "state": "State",
    "city": "City",
    "ip_address": "IP Address",
    "select": "Select",
    "selected": "Selected",
    "leave_empty_no_change": "Leave empty to not change",
    "delete": "Delete",
    "edit": "Edit",
    "editing": "Editing",
    "package": "Package",
    "packages": "Packages",
    "packages_subtitle": "Manage your proxy packages and subscriptions.",
    "no_expiry": "No expiry",
    "save": "Save",
    "actions": "Actions",
    "show": "Show",
    "hide": "Hide",
    "ok": "OK",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "close": "Close",
    "amount": "Amount",
    "quantity": "Quantity",
    "total_requests": "Total Requests",
    "all_records": "All Records",
    "showing_results": "Showing {results} results",
    "cryptocurrencies": "cryptocurrencies",
    "status": "Status",
    "cancel": "Cancel",
    "minutes": "minutes",
    "hours": "hours",
    "hour": "hour",
    "yes": "Yes",
    "no": "No",
    "return_to_site": "Return to site",
    "email": "Email",
    "date": "Date",
    "details": "Details",
    "settings": "Settings",
    "package_name": "Name",
    "failed_to_load": "Failed to load data.",
    "something_went_wrong": "Something went wrong.",
    "copy_failed": "Could not copy to clipboard.",
    "expiring": "Expiring",
    "paused": "Paused",
    "locked": "Locked"
  },
  "rentalOrders": {
    "product": "Proxy type",
    "residential": "Residential proxies",
    "static": "Static proxies",
    "addresses": "IP addresses",
    "expires": "Paid until",
    "renew": "Renew",
    "refresh": "Refresh",
    "history": "Invoices and renewals",
    "purchase": "Purchase proxies",
    "renewal": "Renewal",
    "orders": "Orders",
    "more": "Load more",
    "failed": "Unable to complete the request.",
    "offer": "Offer",
    "payment": "Payment method",
    "wallet": "Wallet",
    "card": "Bank card",
    "crypto": "Cryptocurrency",
    "country": "Billing country (ISO code)",
    "coupon": "Coupon",
    "quote": "Review price",
    "total": "Total",
    "confirm": "Confirm and pay",
    "username": "Username",
    "password": "Password",
    "reveal": "Show password",
    "select": "Select",
    "renewAll": "Select all eligible IPs",
    "selection": "Selected: {count}",
    "term": "Rental term",
    "states": {
      "reserved": "Reserved",
      "expired": "Expired",
      "provisioning": "Provisioning",
      "fulfilled": "Active",
      "paid_unfulfilled": "Paid — awaiting fulfillment",
      "active": "Active",
      "held": "Held for renewal",
      "revoking": "Withdrawing",
      "released": "Released"
    }
  },
  "purchase": {
    "studio": "Proxy purchase",
    "eyebrow": "Workspace / Proxy network",
    "description": "Choose your network, find the right capacity, and keep your next project moving.",
    "moreCapacity": "More capacity.",
    "morePossibilities": "More possibilities.",
    "unitPrice": "Your unit price",
    "fixedRental": "Fixed rental period",
    "noExpiry": "Traffic never expires",
    "trafficPlan": "Traffic plan",
    "loading": "Loading available plans…",
    "noOffers": "No plans available right now",
    "retry": "Try again",
    "dedicatedCapacity": "Dedicated capacity",
    "chooseOffer": "Choose an IP package",
    "availability": "IP availability is confirmed when you continue to payment. Your selected addresses are reserved for checkout.",
    "decrease": "Decrease volume",
    "increase": "Increase volume",
    "volumeUnit": "Volume in {unit}",
    "volumeSlider": "Traffic volume",
    "presets": "Common traffic volumes",
    "pricingTiers": "Volume pricing tiers",
    "bundle": "Choose a traffic bundle",
    "invalidVolume": "Choose an available amount between {min} and {max}.",
    "rentalCoupon": "Your code will be validated when you continue to payment.",
    "promoCode": "Promo code",
    "apply": "Apply",
    "checkingCoupon": "Checking your code for this configuration…",
    "countryHint": "Two-letter country code used for billing.",
    "countryPlaceholder": "US, GB, DE…",
    "companyDetails": "Company & invoice details",
    "optional": "Optional",
    "taxNotice": "Applicable taxes are calculated at checkout using your billing details.",
    "insufficientBalance": "Your balance does not cover this order. Choose another payment method or add funds.",
    "orderTotal": "Order total before tax",
    "review": "Review order",
    "paymentNotice": "Your order will be submitted using the selected payment method.",
    "reviewTitle": "Review your order",
    "subtotal": "Subtotal",
    "reservationNotice": "This price is confirmed for your current configuration. Complete payment before the reservation expires.",
    "back": "Back to configuration",
    "failed": "Unable to complete the request. Please try again.",
    "reservationExpired": "Your reservation has expired. Close this window and review the price again.",
    "configuration": "Your configuration",
    "readyToTailor": "Ready to tailor",
    "onePayment": "One payment for your selected capacity",
    "completeRental": "For the complete rental period",
    "packagePrice": "Package price",
    "estimatedTotal": "Estimated total",
    "keepMoving": "Keep your workflow moving.",
    "setupAfterPayment": "Configure your connection after payment.",
    "quickVolumeSlider": "Quick volume selection",
    "select": "Select",
    "paymentSettingsError": "Unable to load payment methods.",
    "noPaymentMethods": "No payment methods are currently available.",
    "detailsAndPromo": "Details & promo code",
    "chooseCountry": "Select or search country…",
    "totalDiscountHint": "Save {discount} compared with the first tier’s unit price, including any applied promo code."
  },
  "interface": {
    "24_hours": "24 hours",
    "7_days": "7 days",
    "30_days": "30 days",
    "total_traffic": "Total traffic",
    "total_requests": "Total requests",
    "success_rate": "Success rate",
    "outcome_unavailable": "Outcome reporting unavailable",
    "active_connections": "Active connections",
    "across_network": "Across your proxy network",
    "no_previous_data": "No previous-period data",
    "period_change": "{direction} {percent}% vs. previous period",
    "valid_dates": "Choose a valid start and end date.",
    "plenty_capacity": "Plenty of room to keep going.",
    "low_capacity": "Running low? Add more traffic.",
    "plan_capacity": "{name} · {amount} plan",
    "plan_used_percent": "{percent} percent of your plan used",
    "csv_timestamp": "Timestamp (UTC)",
    "csv_traffic": "Traffic (bytes)",
    "csv_data": "Data (bytes)",
    "destination": "Destination",
    "account_owner": "Account owner",
    "user_workspace": "{name} workspace",
    "plan_consumption": "{spent} of {total} used",
    "footer_tagline": "Your connection to more.",
    "ip_whitelist": "IP Whitelist",
    "blacklisted_domains": "Blacklisted Domains",
    "whitelist_description": "Let the right connections in.",
    "blacklist_description": "Keep unwanted destinations out.",
    "access": "Access",
    "rules": "Rules",
    "allowed_ips": "Allowed IP addresses",
    "blocked_domains": "Blocked domains",
    "ip_placeholder": "One IPv4 or IPv6 address per line",
    "domain_placeholder": "One domain or wildcard per line",
    "unsaved_changes": "Unsaved changes",
    "up_to_date": "Up to date",
    "save_whitelist": "Save whitelist",
    "save_rules": "Save rules",
    "invalid_entries": "Invalid entries: {count}",
    "valid_ips": "Valid IPs: {count}",
    "valid_domains": "Valid domains: {count}",
    "blocked_domains_hint": "Requests to these domains will be blocked. Use {pattern} to include all subdomains.",
    "duration_minutes": "{count} min",
    "duration_hours": "{count} h",
    "sticky_hint": "Sticky sessions keep the same IP for the selected duration.",
    "rotating_hint": "Rotating sessions request a new IP on every connection.",
    "traffic_over_time": "{metric} over time, UTC",
    "pagination_count": "{start}–{end} of {total} {label}",
    "matching_results": "No matching results",
    "results": "results",
    "previous_page": "Previous page",
    "next_page": "Next page",
    "api_token_intro": "Use your API token as a static authorization credential for server-to-server requests. For protected endpoints, send the Authorization header in this format:",
    "api_token_secret": "Replace {placeholder} with the token from the list below or the one-time value shown after creation. Keep it private: do not expose it in client-side code, public repositories, or browsers.",
    "api_documentation": "API documentation:",
    "2fa_qr": "2FA QR",
    "subdomain_example_com": "subdomain.example.com",
    "more": "More",
    "fe80_1_lo0": "fe80::1%lo0",
    "scroll_left": "Scroll left",
    "scroll_right": "Scroll right",
    "or": "OR",
    "e_g_500000000_500mb_1gb": "e.g. 500000000, 500mb, 1gb",
    "john_doe_123": "john_doe_123",
    "min_8_characters": "Min. 8 characters",
    "germany": "Germany",
    "united_states": "United States",
    "route_exception": "/ route exception",
    "page_not_found": "Page not found",
    "the_requested_route_is_unavailable_or_may_have_moved": "The requested route is unavailable or may have moved.",
    "return_to_application": "Return to application",
    "workspace_overview": "Workspace overview",
    "your_network_at_a_glance": "Your network, at a glance",
    "a_clear_view_of_your_proxies_performance_and_what_s_next": "A clear view of your proxies, performance, and what’s next.",
    "generate_proxies": "Generate Proxies",
    "latest_news": "Latest news",
    "what_s_new": "WHAT’S NEW",
    "see_update": "See update ↗",
    "dismiss_announcement": "Dismiss announcement",
    "updates_could_not_be_loaded": "Updates could not be loaded.",
    "some_dashboard_data_could_not_be_loaded": "Some dashboard data could not be loaded.",
    "please_try_again": "Please try again.",
    "loading_your_workspace": "Loading your workspace…",
    "no_active_packages": "No active packages",
    "choose_a_proxy_package_to_start_using_your_network": "Choose a proxy package to start using your network.",
    "buy_proxies": "Buy proxies",
    "active_package": "Active package",
    "reporting_period": "Reporting period",
    "export_usage_as_csv": "Export usage as CSV",
    "showing_the_available_activity_records_use_a_shorter_date_range_to_see_more_deta": "Showing the available activity records. Use a shorter date range to see more detail.",
    "key_performance_indicators": "Key performance indicators",
    "traffic_analytics_and_capacity": "Traffic analytics and capacity",
    "usage_statistics": "Usage statistics",
    "understand_how_your_network_performs_over_time": "Understand how your network performs over time.",
    "chart_metric": "Chart metric",
    "in_selected_period": "in selected period",
    "current_period": "Current period",
    "previous_period": "Previous period",
    "data_usage": "Data usage",
    "active_plan": "Active plan",
    "of_your_plan_used": "of your plan used",
    "consumed": "Consumed",
    "plan_details": "Plan details",
    "network_activity": "Network activity",
    "requests_and_top_domains": "Requests and top domains",
    "recent_requests": "Recent requests",
    "the_latest_connections_across_your_network": "The latest connections across your network.",
    "export_filtered_requests": "Export filtered requests",
    "search_domain_or_location": "Search domain or location…",
    "filter_requests": "Filter requests",
    "filter_requests_by_protocol": "Filter requests by protocol",
    "all_protocols": "All protocols",
    "recent_requests_table": "Recent requests table",
    "time_utc": "Time · UTC",
    "no_requests_match_this_period_or_filter": "No requests match this period or filter.",
    "requests": "requests",
    "top_domains": "Top Domains",
    "where_your_traffic_makes_an_impact": "Where your traffic makes an impact.",
    "export_filtered_domains": "Export filtered domains",
    "find_a_domain": "Find a domain…",
    "search_top_domains": "Search top domains",
    "sort_top_domains": "Sort top domains",
    "by_traffic": "By traffic",
    "by_requests": "By requests",
    "top_domains_table": "Top domains table",
    "traffic": "Traffic",
    "no_domains_match_this_period_or_filter": "No domains match this period or filter.",
    "domains": "domains",
    "build_manage": "Build & manage",
    "everything_you_need_to_get_connected": "Everything you need to get connected.",
    "proxy_tools": "Proxy tools",
    "choose_a_reporting_period": "Choose a reporting period",
    "start_date": "Start date",
    "end_date": "End date",
    "apply_date_range": "Apply date range",
    "skip_to_content": "Skip to content",
    "workspace_navigation": "Workspace navigation",
    "workspace": "Workspace",
    "main_navigation": "Main navigation",
    "resources": "Resources",
    "preferences": "Preferences",
    "view_your_plan": "View your plan",
    "open_navigation": "Open navigation",
    "system_status": "System status",
    "product_updates": "Product updates",
    "legal": "Legal",
    "terms": "Terms",
    "privacy": "Privacy",
    "workspace_preferences": "Workspace preferences",
    "appearance": "Appearance",
    "account_settings": "Account settings",
    "ui_kit": "UI Kit",
    "clarity_design_system": "Clarity · Design system",
    "the_components_patterns_and_states_behind_your_workspace": "The components, patterns, and states behind your workspace.",
    "open_sample_dialog": "Open sample dialog",
    "foundation": "Foundation",
    "semantic_colors_adapt_to_the_selected_light_or_dark_appearance": "Semantic colors adapt to the selected light or dark appearance.",
    "clear_hierarchy_familiar_patterns": "Clear hierarchy. Familiar patterns.",
    "inter_page_title_30_panel_title_15_body_13_control_11_4_px_spacing_grid_14_px_ca": "Inter · page title 30 / panel title 15 / body 13 / control 11 · 4 px spacing grid · 14 px cards · 7 px controls",
    "one_primary_action_per_group_keep_secondary_actions_quiet": "One primary action per group. Keep secondary actions quiet.",
    "primary_action": "Primary action",
    "secondary": "Secondary",
    "text_action": "Text action",
    "delete_rule": "Delete rule",
    "unavailable": "Unavailable",
    "status_feedback": "Status & feedback",
    "use_a_label_with_every_status_never_rely_on_color_alone": "Use a label with every status; never rely on color alone.",
    "processing": "Processing",
    "low_balance": "Low balance",
    "draft": "Draft",
    "information": "Information",
    "changes_apply_after_you_save": "Changes apply after you save.",
    "saved": "Saved",
    "your_settings_are_up_to_date": "Your settings are up to date.",
    "running_low": "Running low",
    "add_traffic_to_keep_your_proxies_connected": "Add traffic to keep your proxies connected.",
    "unable_to_save": "Unable to save",
    "check_the_highlighted_fields_and_try_again": "Check the highlighted fields and try again.",
    "forms": "Forms",
    "persistent_labels_contextual_help_and_inline_validation": "Persistent labels, contextual help, and inline validation.",
    "workspace_name": "Workspace name",
    "a_name_your_team_will_recognize": "A name your team will recognize.",
    "acme_workspace": "Acme workspace",
    "europe": "Europe",
    "validation_example": "Validation example",
    "i_agree_to_the_workspace_policy": "I agree to the workspace policy",
    "save_example": "Save example",
    "example_saved_for_this_visit": "Example saved for this visit.",
    "selection_navigation": "Selection & navigation",
    "compact_controls_with_explicit_selected_and_disabled_states": "Compact controls with explicit selected and disabled states.",
    "example_chart_metric": "Example chart metric",
    "session_type": "Session type",
    "notifications": "Notifications",
    "receive_updates_about_your_workspace": "Receive updates about your workspace.",
    "searchable_selection": "Searchable selection",
    "report_date": "Report date",
    "notes": "Notes",
    "one_entry_per_line": "One entry per line.",
    "add_a_note": "Add a note…",
    "disabled_control": "Disabled control",
    "tables": "Tables",
    "scan_friendly_rows_contextual_badges_and_bounded_pagination": "Scan-friendly rows, contextual badges, and bounded pagination.",
    "examples": "examples",
    "analytics": "Analytics",
    "sample_traffic_utc_focus_a_point_to_see_its_value_use_the_dashboard_metric_contr": "Sample traffic · UTC. Focus a point to see its value; use the dashboard metric control to change real reports.",
    "volume_studio": "Studio configurator",
    "the_default_purchase_pattern_this_gallery_uses_sample_values_checkout_uses_the_a": "The default purchase pattern. This gallery uses sample values; checkout uses the API catalog and verified pricing.",
    "example_traffic_volume": "Example traffic volume",
    "move_the_slider_to_preview_the_capacity_visualization": "Move the slider to preview the capacity visualization.",
    "network_and_package_selection_occupy_this_panel_promo_codes_billing_details_and_": "Network and capacity controls are here, with payment methods below. Your configuration brings the total, promo code and invoice details together in the side panel.",
    "promo_code_company_details": "Promo code & company details",
    "payment_method_order_review": "Payment method & order review",
    "example_checkout": "Example checkout",
    "empty_state": "Empty state",
    "no_requests_yet": "No requests yet",
    "your_activity_will_appear_here_after_the_first_connection": "Your activity will appear here after the first connection.",
    "view_connection_guide": "View connection guide",
    "loading_error_states": "Loading & error states",
    "loading_your_activity": "Loading your activity…",
    "unable_to_load_activity": "Unable to load activity",
    "check_your_connection_and_try_again": "Check your connection and try again.",
    "create_a_connection": "Create a connection",
    "connection_name": "Connection name",
    "production_crawler": "Production crawler",
    "create_connection": "Create connection",
    "only_listed_ips_can_access_your_proxies_leave_this_empty_to_allow_connections_fr": "Only listed IPs can access your proxies. Leave this empty to allow connections from any IP.",
    "exact_domain": "Exact domain:",
    "subdomains": "Subdomains:",
    "enter_one_value_per_line": "Enter one value per line.",
    "reset_changes": "Reset changes",
    "your_next_connection_starts_here": "Your next connection starts here.",
    "quick_start": "Quick start",
    "choose_your_plan_location": "Choose your plan & location",
    "proxy_plan": "Proxy plan",
    "location_targeting": "Location targeting",
    "location_targeting_mode": "Location targeting mode",
    "country_city": "Country / city",
    "continent_targeting_replaces_country_region_city_and_asn_targeting": "Continent targeting replaces country, region, city, and ASN targeting.",
    "any_region": "Any region",
    "any_city": "Any city",
    "any_asn_isp": "Any ASN / ISP",
    "configure_your_connection": "Configure your connection",
    "output_format": "Output format",
    "session_duration": "Session duration",
    "number_of_proxies": "Number of proxies",
    "generated_proxies": "Generated proxies",
    "choose_your_settings_then_generate_your_proxy_list": "Choose your settings, then generate your proxy list.",
    "your_proxy_credentials_keep_this_list_private": "Your proxy credentials · keep this list private.",
    "no_usage_in_this_period": "No usage in this period",
    "your_traffic_will_appear_here_once_requests_are_recorded": "Your traffic will appear here once requests are recorded.",
    "clear_selection": "Clear selection",
    "proxy_generator": "Proxy generator",
    "generate_ready_to_use_credentials_for_an_active_order": "Generate ready-to-use credentials for an active order.",
    "country_code": "Country code",
    "optional_for_example_us": "Optional, for example US",
    "sticky_session_seconds": "Sticky session, seconds",
    "copy_all": "Copy all",
    "delivery_details": "Delivery Details",
    "your_name": "Your name",
    "your_email_required": "Your email*",
    "country_required": "Country*",
    "australia": "Australia",
    "france": "France",
    "spain": "Spain",
    "united_kingdom": "United Kingdom",
    "city_required": "City*",
    "new_york": "New York",
    "los_angeles": "Los Angeles",
    "chicago": "Chicago",
    "houston": "Houston",
    "phone_number_required": "Phone Number*",
    "united_states_1": "United States (+1)",
    "united_kingdom_44": "United Kingdom (+44)",
    "australia_61": "Australia (+61)",
    "germany_49": "Germany (+49)",
    "france_33": "France (+33)",
    "company_name": "Company name",
    "vat_number": "VAT number",
    "pay_with_your_credit_card_via_stipe": "Pay with your credit card via Stipe",
    "15_payment_processing_fee": "+$15 payment processing fee",
    "paypal": "Paypal",
    "connect_to_your_account": "Connect to your account",
    "enter_a_gift_card_voucher_or_promotional_code": "Enter a gift card, voucher or promotional code",
    "tax": "Tax",
    "proceed_to_payment": "Proceed to Payment",
    "tabs": "Tabs",
    "loading": "Loading…",
    "fetching_announcements": "Fetching announcements",
    "contact_us": "Contact Us",
    "got_a_technical_issue_want_to_send_feedback_about_a_beta_feature_need_details_ab": "Got a technical issue? Want to send feedback about a beta feature? Need details about our Business plan? Let us know.",
    "your_email": "Your email",
    "subject": "Subject",
    "let_us_know_how_we_can_help_you": "Let us know how we can help you",
    "your_message": "Your message",
    "leave_a_comment": "Leave a comment...",
    "send_message": "Send message",
    "payments_are_processed_securely_no_card_details_are_stored_on_our_servers": "Payments are processed securely. No card details are stored on our servers.",
    "enter_amount": "Enter amount",
    "method": "Method:",
    "request_failed": "Request failed",
    "no_activity": "No activity",
    "pagination": "Pagination",
    "records": "records",
    "checkout": "Checkout",
    "marketing": "Marketing",
    "contact_support": "Contact support",
    "stablecoin": "Stablecoin",
    "network_coin": "Network coin",
    "card_required": "Card number is required",
    "card_length": "Card number must be between 13 and 19 digits",
    "expiry_required": "Expiration date is required",
    "expiry_format": "Expiration date must be in MM/YY format",
    "security_code_required": "Security code is required",
    "security_code_length": "Security code must be 3 or 4 digits",
    "amount_required": "Amount is required",
    "amount_number": "Amount must be a number",
    "amount_integer": "Amount must be a whole number (no decimals)",
    "amount_min": "Minimum amount is 20",
    "amount_max": "Maximum amount is 10,000",
    "no_user": "No user selected",
    "invalid_size": "Invalid size format. Use e.g. 500000000, 50mb, 1gb, 2.5tb",
    "data_required": "Data amount is required",
    "no_package": "No package selected",
    "generation_failed": "Generation failed",
    "credentials_copied": "Credentials copied",
    "generating": "Generating…",
    "generate_credentials": "Generate credentials",
    "threshold_range": "Threshold must be between 5% and 50%",
    "threshold_min": "Must be at least 5%",
    "threshold_max": "Must be at most 50%",
    "topup_min": "Must be at least 1 GB",
    "topup_max": "Must be at most 10,000 GB",
    "invalid_threshold": "Invalid threshold",
    "no_data": "No data yet",
    "activity_chart": "Activity chart",
    "valid_ip": "Enter a valid IP address.",
    "choose_plan": "Choose a plan first",
    "example_network": "Residential · Example",
    "example_period": "30-day example plan",
    "no_options": "No options available",
    "language_load_failed": "Could not load this language. Please try again.",
    "request_method": "Method",
    "user_ip": "User IP",
    "server_ip": "Server IP",
    "search_min_chars": "Enter at least {count} characters to search."
  },
  "plans": {
    "unlimited": "Unlimited",
    "renew": "Renew"
  },
  "legal": {
    "privacy": {
      "b01": "This Privacy Policy describes how {brand} (\"we\", \"us\", or \"our\") collects, uses, and discloses your information when you use our services at {site}.",
      "b02": "Privacy Policy",
      "b03": "We are dedicated to protecting our website’s visitors and service users’ privacy.",
      "b04": "Throughout this policy, \"we\", \"us\" and \"our\" refer to {brand} Services PTY LTD.",
      "b05": "Our services inside {site} are subject to the privacy policies of this Statement (the “website” or \"Service\"). You agree to be governed by the rules set forth in this privacy policy when you access this website.",
      "b06": "Please do not use or visit our Service if you do not agree.",
      "b07": "This page explains our policies for collecting, using, and disclosing personal information when you use our Service, as well as your options for dealing with such data.",
      "b08": "Your information is used to deliver and improve the experience of the Service. You consent to the process and collection in line with this policy by using the Service. Terms written in this Privacy Policy have the same definitions as in our Terms and Conditions, unless otherwise stated in this Privacy Policy.",
      "b09": "The Data we Collect and Use",
      "b10": "We collect a variety of data for a variety of reasons in order to offer and enhance our service to you.",
      "b11": "Types of Data Collected",
      "b12": "General Personal Information:",
      "b13": "We may request that you supply us with personal data that can be used to contact or identify you while using our Service (\"Personal Data\"). Information that can be used to identify you includes, but is not limited to:",
      "b14": "Email address",
      "b15": "Full name",
      "b16": "IP Address",
      "b17": "Cookies and Usage Data:",
      "b18": "Personal Data is presented as data that identifies, corresponds to, characterizes, references, is competent of being attributed with, or could reasonably be connected, directly or indirectly, with a specific individual or device for the purposes of this Privacy Policy, but does not include data that is not considered personal data (or roughly equivalent terms) by relevant data privacy laws.",
      "b19": "Usage Data:",
      "b20": "We may also gather data about how the Service is used and viewed (\"Usage Data\"). This Usage Data may consist of your device's Internet Protocol address (e.g., IP address), the pages of our website that you view, the date and time of your visit, and other relevant things. Under relevant data privacy regulations, Usage Data may be considered Personal Data.",
      "b21": "Tracking & Cookies Data:",
      "b22": "To track activities on our Service and store certain information, we utilize cookies and similar tracking technologies.",
      "b23": "Cookies are tiny data files that may or may not contain an anonymous unique identification. Cookies are little text files that a website sends to your browser and stores on your device. Beacons, tags, and scripts are examples of tracking technologies that are used to gather and track data, as well as to enhance and evaluate our Service.",
      "b24": "You may set your browser to reject all cookies or to notify you when one is received. You may not be able to access some parts of our Service if you refuse to accept cookies",
      "b25": "To illustrate, we provide the following cookies:",
      "b26": "Preference Cookies",
      "b27": "Security Cookies",
      "b28": "Session Cookies",
      "b29": "Use of Data",
      "b30": "The reasons why we collect your data are the following:",
      "b31": "To supply and preserve the Service",
      "b32": "To inform you regarding modifications to our Service",
      "b33": "To enable you to partake in interactive content of our Service when you choose",
      "b34": "To supply customer help and treatment",
      "b35": "To supply assessment or useful information so that we can improve the Service",
      "b36": "To oversee the usage of the Service",
      "b37": "To trace, avert, and resolve technical problems",
      "b38": "Transfer of Data",
      "b39": "Your data, including Personal Data, may be transmitted to and stored on data centers outside of your location, country, or other jurisdiction, where data protection regulations may vary from those in your territory.",
      "b40": "If you wish to send data to us from outside Australia, please be aware that we will transmit the data, including Personal Data, to Australia and analyze it there.",
      "b41": "Your assent to that transfer is based on your acceptance of this Privacy Policy and your submission of such data.",
      "b42": "We will take all reasonable measures to protect that your data is safeguarded and in connection with the Services, and no transition of your Personal Data to an individual or company will occur unless sufficient controls, including data and other personal data security, have been established.",
      "b43": "Disclosure of Data - Legal Requirements",
      "b44": "We may divulge your Personal Data if we have a reason to believe that it is essential to:",
      "b45": "abide with a legal requirement;",
      "b46": "uphold our rights or property;",
      "b47": "avert or examine potential impropriety in relation to the Service;",
      "b48": "or protect the personal safety of our consumers or the wider public.",
      "b49": "Safeguarding of Data",
      "b50": "We care about the safety of your information, but keep in mind that no method of Internet transfer or computer storage is completely safe. While we make every effort to secure your Personal Data using commercially reasonable measures, we cannot assure its ultimate security.",
      "b51": "Users on behalf of a company or organisation",
      "b52": "We consider data obtained from persons working on behalf of entities (rather than individuals) as information submitted to us by that entity according to our Privacy Policy. As a company using our Service, you recognize and guarantee that (i) you have all required permissions to provide us with all Personal Data presented to our Service by any individual acting as your representative, and (ii) also every individual whose Personal Data you supply to us has given their consent to the provision of such Personal Data and its use as info supplied to us.",
      "b53": "Independent Contractors",
      "b54": "We may hire third-party organizations and people to help us deliver our Service (\"Independent Contractors\"), supply the Service as our representatives, execute Service-related tasks, or help us in evaluating how our Service is utilised.",
      "b55": "These independent contractors and service providers have seen your Personal Data and Information only to conduct their responsibilities as our representatives and must not divulge or utilise it for any other reason.",
      "b56": "Analytics",
      "b57": "We may use third-party independent contractors to oversee and examine the utilisation of our Service. Despite the fact that we maintain the absolute, sole and full right to select additional third-party independent contractors to conduct analytics operations associated with the Service, our current third-party independent contractors include:",
      "b58": "Google Analytics",
      "b59": "Links to Other Websites",
      "b60": "Our Service may consist of links to third-party websites that are not under our control. You will be taken to the third party's website if you click on a third-party link. We highly urge you to read the Privacy Policies and associated conditions of the websites you visit since they will control your activities with those websites. We have no responsibility for the content, internal policies, or activities of any third-party websites, and we disclaim any liability for them.",
      "b61": "Privacy Laws",
      "b62": "For the reasons of controlling your data, we operate as a Data Controller, as stated by the General Data Protection Regulation (GDPR), and we process personal information for our legitimate interests and contractual requirement in supplying you with the Service, as further provided in this policy. Personal data is also processed and shared once our users have been notified and given their consent.",
      "b63": "Minors",
      "b64": "Anyone under 18 years of age is not permitted to use our Service.",
      "b65": "We do not intentionally collect personal data from children under the age of eighteen. Please feel free to contact us if you are a parent or guardian and you are aware that your kid has supplied us with Personal Data. If we learn that we have acquired Personal Data from anyone under 18 years of age without parents' permission, we will take reasonable efforts to delete such data from our systems.",
      "b66": "Amendments",
      "b67": "We reserve the right to change this policy at any moment by posting a new version on our App.",
      "b68": "You should revisit this page on a regular basis to confirm that you are satisfied with any changes to this policy.",
      "b69": "We may send you an email if we make changes to this policy.",
      "b70": "Contact Info",
      "b71": "We might be reached by email at the following email address: {email}"
    },
    "terms": {
      "b01": "Please read our Terms of Service carefully before using our Service.",
      "b02": "Introduction",
      "b03": "Prior to visiting, using and/or browsing the website with the following address: {site} (collectively and with all related services and activities, the \"Service\") managed by {brand} Services PTY LTD (\"us\", \"we\", or \"our\"), please read and check these Terms and Conditions (\"Terms\", \"Terms and Conditions\").",
      "b04": "Adhering to and following these Terms and Conditions are required for visiting, browsing and using the Service. All visitors, users, customers and others who desire to visit, enter, browse or use the Service are bound by these Terms and Conditions. Users of the Service shall be referred to as \"users,\" \"you,\" \"your,\" and other similar words. If you are visiting, browsing and/or using the Service on behalf of an organization, company or firm these Terms apply to the organization, company or firm, and you and the organization, company or firm warrant that you and the organization, company or firm have complete power to approve and enter into these Terms and Conditions, and your affirmation of these Terms and Conditions binds the organization, company or firm.",
      "b05": "You abide by these Terms by browsing, using or visiting the Service. You do not have authorization to use the Service if you dispute with any element of the Terms.",
      "b06": "Subscriptions",
      "b07": "Expenses and additional conditions will be taken into account at the moment you subscribe to the Service; all such conditions are integrated as part of these Terms and Conditions. Certain elements of the Service are charged on a subscription basis (\"Subscription(s)\"). You will be charged in ahead of time on a repeating and periodic basis (\"Billing Cycle\"). Predicated on the sort of subscription plan you choose when acquiring a Subscription, billing cycles are either monthly or annually.",
      "b08": "Except if you terminate your Subscription or we suspend or close your account, your Subscription will be automatically renewed at the conclusion of each Billing Cycle under the same circumstances. You can terminate your Subscription renewal at any time by visiting your online account management page or contacting our customer service at {email}.",
      "b09": "To complete your Subscription payment, you'll need a legitimate payment method, such as a credit card or PayPal. You agree to give complete and reliable billing information to us, including your full name, address, region, zip code, phone number, and a legitimate payment method. You automatically permit {brand} Services PTY LTD to bill all Subscription costs incurred via your account to any such payment methods by entering such payment details.",
      "b10": "If automated charging fails for whatever reason, we will send you an online invoice with instructions on how to manually pay the entire amount due for the payment period stated on the invoice by a specific deadline. We retain the sole, absolute and complete right to terminate or cancel any account if a relevant payment is not received, or if payment difficulties are recurrent or if payment problems constitute Forbidden Activity (as outlined below).",
      "b11": "Fee Adjustments",
      "b12": "We have the absolute right to change the Subscription costs at any moment and at our exclusive, absolute and complete discretion. Any changes to Subscription fees will take effect at the conclusion of the existing Billing Cycle.",
      "b13": "Any adjustment in Subscription rates will be communicated to you with sufficient advance notice to allow you to cancel your Subscription prior to the adjustment takes effect.",
      "b14": "Ongoing use of the Service subsequent to the Subscription price adjustment takes effect signifies your consent to be charged the amended Subscription fee sum and your agreement of these Terms and Conditions.",
      "b15": "No Refunds",
      "b16": "We do not provide any refunds or replacements unless in exceptional circumstances. All sales are final.",
      "b17": "Accounts",
      "b18": "When you sign up with us, you represent and warrant that you are at least 18 years old, that the data you give us is reliable, complete, and the latest at all times, and that you have all legal permissions and power to give us such information and to enter into these Terms and Conditions on behalf of the applicable person or company. Your account on the Service may be immediately terminated if you provide incorrect, inadequate, or outdated data.",
      "b19": "You are liable and responsible for keeping your account and password secure, including but not limited to limiting access to your PC and/or account. Whether your password is with us or a third-party provider, you consent to have liability for any and all behaviors or acts that happen under your account and/or password. If you become aware of a security violation or improper use of your account, you must tell us instantly.",
      "b20": "Copyright Policy",
      "b21": "Others' copyrights and intellectual property rights are respected by us. It is our policy to react to any accusation that Content on the Service violates on another individual's or company's copyright or other intellectual property rights (\"Violation\").",
      "b22": "If you are a copyright owner, or permitted on behalf of a copyright owner, and think that a copyrighted work has been plagiarised in a way that constitutes copyright violations, please send an email to {email} with the subject line \"Copyright Violation\" and provide a complete explanation of the alleged violation as provided below, under \"DMCA Notice and Procedure for Copyright Violations\".",
      "b23": "DMCA Notice and Procedure for Copyright Violations",
      "b24": "You may file a notice under the Digital Millennium Copyright Act (DMCA) by writing to our Copyright Agent and giving the following information (for more information, see 17 U.S.C. 512(c)(3)):",
      "b25": "an explanation of the copyrighted work that you allege has been violated, along with the URL (i.e., site address) of the location where the copyrighted work appears or a duplicate of the copyrighted work;",
      "b26": "identification of the URL or other specific location on the Service where the material that you allege is violating has appeared;",
      "b27": "a signature of the person permitted to act on behalf of the owner of the copyright interest, whether electronic or physical;",
      "b28": "your name, address, phone number, and email address; a declaration from you that the disputed use is not permitted by the copyright owner, its agent, or the law; and",
      "b29": "a declaration signed under penalty of perjury that the above information in your notification is correct and that you are the copyright owner or permitted to act on behalf of the copyright owner.",
      "b30": "Our Copyright Agent may be reached at {email}.",
      "b31": "Intellectual Property Rights",
      "b32": "We and our licensors own and control the Service, as well as its original content, features, and operation. Copyright, trademark, and other laws in the United States of America (USA) and other countries safeguard the Service. Without our prior written authorization, our trademarks and trade dress may not be utilized in conjunction with any product or service.",
      "b33": "Any inquiries, opinions, recommendations, comments, feedback, or other material you send to us about the Website or Services (\"Feedback\") is non-confidential and becomes our exclusive property. We will hold the exclusive rights to Feedback, along with all intellectual property rights, and will be free to use and distribute it for any legal purpose, commercial or otherwise, without acknowledgement or remuneration to you. You hereby renounce all moral rights to any such Feedback and guarantee that any such Feedback is original to you or that you have the authority to submit it. You acknowledge that you will have no recourse against us if your Feedback is allegedly or really infringed upon or misappropriated.",
      "b34": "Privacy Policy",
      "b35": "Our Privacy Policy, which is authorized to enter and constitutes a part of these Terms, governs your use of the Service. Despite the fact that we backup data on a consistent basis, you are entirely liable for all data you submit or that pertains to any behavior you have performed using the Service. You agree that we will not be liable to you for any damage or contamination of such data, and you accept to waive any right of action you may have against us as a result of such contamination or damage.",
      "b36": "Links to Other Websites",
      "b37": "Our Service may give access to third-party websites or services that are not within our management.",
      "b38": "We have no responsibility over, and takes no liability for, any third-party links or services, including their content, privacy policies, or practices. We make no representations or warranties about these organizations and persons or their websites.",
      "b39": "You understand and accept that we are not responsible or liable, explicitly or implicitly, for any harm or loss caused or alleged to be caused by or in connection with the use of or dependence on any such material, goods, or offering services on or via any such third-party links or services.",
      "b40": "You are responsible for reading the legal documents such as terms of service and privacy policy of such third-party links or services.",
      "b41": "Forbidden Activity",
      "b42": "If you engage in any “Forbidden Activity” while using any part of the Service, including any of our Proxies, your account may be suspended. The following are examples of forbidden activity:",
      "b43": "Spamming",
      "b44": "Using a PC or a website without permission or in excess of permission.",
      "b45": "Scanning for ports or vulnerabilities, as well as brute-forcing passwords.",
      "b46": "Viruses, adware, and spyware of any type are distributed.",
      "b47": "In conjunction with your use of the Service, you have broken the law.",
      "b48": "Signing up to a different account subsequent to us canceling or banning your account",
      "b49": "Any other behavior that obstructs or has the effect of obstructing the functioning of our Service, or that is used for an inappropriate purpose.",
      "b50": "We maintain the absolute, sole and full right, in our sole discretion, to restrict or cancel your account for any violation of our Service or any misbehavior by you in accordance with these Terms and Conditions.",
      "b51": "Suspension / Termination of Accounts",
      "b52": "We may, in our sole discretion, cancel or restrict your account and deny you access to the Service without advance notification or responsibility, for any cause and without restriction, including but not limited to a violation of these Terms.",
      "b53": "We may deactivate or cancel your account for any of the following reasons, without limitation:",
      "b54": "Using any unauthorized or incorrect payment method in accordance with your use of, or payment for, the Service.",
      "b55": "Acting in any of the Forbidden Activity stated above.",
      "b56": "If your account is suspended by us, you may contact us at {email} and provide us with any information you feel is relevant to the restriction. We have the sole and absolute right to make all decisions regarding the restriction of any account.",
      "b57": "If we restrict an account and later reinstates it, the term of the Subscription in effect will be prolonged for the duration of the restriction.",
      "b58": "You can simply stop using the Service if you want to close your account",
      "b59": "All sections of the Terms that, by their nature, should survive termination, such as ownership provisions, warranty disclaimers, indemnification, and liability limits, shall survive termination.",
      "b60": "Indemnification",
      "b61": "You accept to defend, indemnify, and hold harmless {brand} Services PTY LTD, and its licensees and licensors, and their employees, suppliers. independent contractors, affiliates and directors, from and against any and all allegations, harms, responsibilities, injuries, obligations, charges or loans, and fees (including but not limited to legal costs) in consequence from or arising out of a) your use and visit of the Service.",
      "b62": "Limitation of Liability",
      "b63": "It is important to emphasise that we will act to the best of its capability, capacity and knowledge to perform our responsibilities under these Terms and Conditions as best as reasonably possible by us, but we cannot be liable for any injury, harm, loss, loss of revenue/profits, damage or anything else that occurs while you are visiting, browsing or using the Service.",
      "b64": "Disclaimer Warranties",
      "b65": "Everything within the Service is provided on an “as is” basis. We are not responsible for how you use the Service across the internet on your device and the content of the Service may have inaccuracies, errors and/or typographical errors.",
      "b66": "No Agency",
      "b67": "Nothing in this Agreement shall establish or be construed to constitute any joint venture, agency, or partnership arrangement between us and you. You shall not represent yourself as having any such relationship with us.",
      "b68": "Governing Laws and Jurisdiction",
      "b69": "These terms and conditions are governed by the laws of Australia and the participants consent to the exclusive jurisdiction of the courts of Australia. Using the Service in areas where the Service is unlawful, is strictly forbidden and you should comply with all local laws when using the Service outside of Australia.",
      "b70": "General Provisions",
      "b71": "We have the right to make changes to these Terms and Conditions at any time. The most recent version of these Terms and Conditions will be posted online on the website.",
      "b72": "We will not be responsible to you if we fail to execute our duties under these Terms and Conditions due to any cause beyond our immediate control.",
      "b73": "Our inability to assert or execute our rights, or to provide any forbearance, delay, or indulgence, shall not be interpreted as a waiver of such rights under these Terms and Conditions or otherwise.",
      "b74": "These Terms and Conditions constitute the whole agreement between the Parties concerning the subject matter.",
      "b75": "If any of the provisions in these Terms and Conditions are found to be illegal, invalid or unenforceable, the rest of these Terms and Conditions survives and continues to be valid, if necessary.",
      "b76": "You may print and retain a copy of these Terms and Conditions for your records.",
      "b77": "If you need to get in touch with us for any reason, please do so by sending an email to: {email}"
    }
  },
  "validation": {
    "invalid": "Enter a valid value.",
    "choice": "Select a valid option.",
    "email": "Enter a valid email address.",
    "min_length": "Use at least {min} characters.",
    "max_length": "Use no more than {max} characters.",
    "min_number": "Enter a value of at least {min}.",
    "max_number": "Enter a value no greater than {max}.",
    "integer": "Enter a whole number."
  },
  "api": {
    "request_failed": "API request failed.",
    "load_packages": "Unable to load packages.",
    "load_orders": "Unable to load orders.",
    "generate": "Unable to generate proxy credentials.",
    "login": "Unable to sign in.",
    "load_account": "Unable to load the account.",
    "google": "Unable to sign in with Google.",
    "signup": "Unable to create the account.",
    "recover": "Unable to send password recovery instructions.",
    "invoice": "Unable to create the invoice.",
    "coupon": "Unable to validate the promo code."
  },
  "usersStudio": {
    "workspace": "People & access",
    "usersHint": "Your users, packages and traffic in one place.",
    "room": "A little room to grow",
    "connected": "More people. One connected workspace.",
    "capacityHint": "Keep your users moving, with the right amount of traffic for each one.",
    "remaining": "remaining across your users",
    "assigned": "assigned packages",
    "statistics": "User statistics",
    "statisticsHint": "Follow traffic and requests over time.",
    "allWorkspace": "Account and sub-users",
    "utc": "Reporting timezone: UTC",
    "people": "People & capacity",
    "choose": "Choose a user to manage their packages and access.",
    "search": "Search username or email",
    "allPackages": "All packages",
    "noUsers": "No users found",
    "noUsersHint": "Create a user or change your search filters.",
    "assignedPackages": "Assigned packages",
    "selectedData": "Selected package data",
    "used": "used",
    "userPackage": "Package for {name}",
    "generateField": "Generate {field}",
    "usernameFixed": "The username is set when the account is created.",
    "passwordHint": "Leave blank to keep the current login password.",
    "invalidRules": "Check the IP addresses and domains, one per line.",
    "saved": "Changes saved.",
    "createHint": "Set up login credentials and optionally assign a package and traffic.",
    "overview": "Overview",
    "settings": "Account settings",
    "settingsHint": "Login credentials for this user.",
    "userNavigation": "User workspace sections",
    "selectPackageHint": "Choose a package to view its activity or generate proxies.",
    "assignPackage": "Assign package",
    "noPackage": "Create without a package",
    "loadingPackages": "Loading your package orders…",
    "packagesLoadError": "Could not load package orders. You can still create a user without a package.",
    "noPackages": "No package orders found. You can still create a user without a package.",
    "availableData": "Available: {data}",
    "initialAllocation": "Initial traffic allocation (GiB)",
    "createAllocationHint": "Enter the amount of traffic to assign to this user.",
    "positiveAllocation": "Enter a traffic amount greater than zero.",
    "noAssigned": "Assign a package to start using proxies.",
    "adjustAllocation": "Manage data allocation",
    "rotatePassword": "Rotate proxy password",
    "rotateConfirm": "Existing proxy credentials for this package will stop working. Generate new proxies after the password changes.",
    "removePackage": "Remove package",
    "removeConfirm": "Remove {name} from this user? Its proxy credentials will stop working.",
    "deleteUser": "Delete user",
    "deleteConfirm": "Delete {name} and their assigned packages? This cannot be undone.",
    "rulesScope": "Access rules apply to this user across all assigned packages.",
    "allocationHint": "Manage traffic for the selected user and package.",
    "operation": "Operation",
    "addData": "Add data",
    "subtractData": "Return data",
    "amount": "Data amount",
    "allocationAccounting": "Funded packages transfer available traffic. Reseller quotas share the parent pool. Usage already recorded is preserved.",
    "noOwnedPackages": "You need an eligible package before assigning traffic.",
    "validAmount": "Enter a positive data amount within the allowed limit.",
    "staticPackage": "This is a static IP rental. Traffic allocation and the traffic proxy generator do not apply to this package.",
    "twoFactorRequired": "Two-factor authentication is required to sign in to this account.",
    "removeData": "Remove data",
    "resetData": "Reset data",
    "resetHint": "Reset all remaining traffic for this package to zero. Usage history is preserved.",
    "unlimitedReset": "Unlimited packages cannot be reset.",
    "insufficientData": "You can remove at most {remaining} of remaining traffic."
  },
  "invoiceLedger": {
    "title": "Invoice history",
    "description": "Keep track of purchases, top-ups, and payouts.",
    "allInvoices": "All invoices",
    "allProducts": "All products",
    "allMethods": "All payment methods",
    "search": "Search invoice number or email",
    "productFilter": "Filter by product",
    "product": "Package / product",
    "traffic": "Traffic packages",
    "amount": "Amount",
    "manual": "Manual payment",
    "download": "Download PDF",
    "empty": "Your purchases and balance top-ups will appear here.",
    "emptyFiltered": "Try another search or clear your filters to see your billing history.",
    "clearFilters": "Clear filters",
    "help": "Pay pending invoices directly. Download a PDF receipt after payment.",
    "paymentFailed": "Unable to open payment. Please try again."
  },
  "staticInventoryFlow": {
    "title": "Add static inventory",
    "description": "Add CIDR networks or individual public IP addresses. Review the import before saving.",
    "country": "Proxy country",
    "countryHint": "Required location for newly added IPs.",
    "region": "Region",
    "city": "City",
    "regionHint": "Optional region within the selected country.",
    "cityHint": "Optional city. Selecting a city also selects its region.",
    "source": "Input format",
    "sourceHint": "CIDR expands into linked IP addresses. Individual IPs join a matching subnet or a new /32.",
    "serverHint": "Choose the static proxy server hosting these addresses.",
    "cidrHint": "One public IPv4 CIDR per line, /24–/32, up to 32 networks. Network and broadcast addresses are excluded except for /31 and /32.",
    "created": "New IPs",
    "existing": "Already in inventory",
    "invalid": "Choose a server and country and enter valid public IPv4 addresses or CIDRs.",
    "discard": "Discard unsaved inventory changes?",
    "readyHint": "IPs become available after the server network is ready.",
    "defaultsHint": "Subnet defaults apply only to newly added IPs. Existing addresses keep their settings.",
    "tieredPricing": "Volume pricing",
    "tieredHint": "The selected tier price applies to every IP. Purchase and renewal prices are independent.",
    "fromQuantity": "From quantity",
    "purchaseUnit": "Purchase / IP",
    "addTier": "Add price tier",
    "legacyOffers": "Existing fixed bundles remain available until explicitly disabled.",
    "invalidTiers": "Start at one IP; use unique quantities and positive unit prices that do not increase.",
    "any": "Any",
    "quantity": "IP quantity",
    "available": "Available: {count} IPs",
    "unitPrice": "Price per IP",
    "byLocation": "Choose location",
    "bundles": "Fixed bundles",
    "replacements": "Replacement requests",
    "approvalHint": "Select IPs from one order. Replacement requires administrator approval and keeps the paid rental period.",
    "reason": "Reason",
    "not_working": "Not working",
    "slow_speed": "Slow speed",
    "blocked": "Blocked",
    "other": "Other reason",
    "details": "Reason details, up to 255 characters",
    "requestReplacement": "Request replacement",
    "pending": "Awaiting approval",
    "processing": "Processing",
    "needs_manual": "Manual selection needed",
    "completed": "Completed",
    "provisioning": "Configuring replacement",
    "ineligible": "Rental no longer eligible",
    "rejected": "Rejected",
    "approve": "Approve",
    "reject": "Reject",
    "comment": "Administrator comment",
    "locationComment": "Required when changing the IP location.",
    "replacementIp": "Replacement IP",
    "noRequests": "No replacement requests.",
    "partial": "Partially completed"
  },
  "accountWorkspace": {
    "personal": "Personal details",
    "company": "Company & billing",
    "security": "Security",
    "integrations": "Integrations",
    "integrationsHint": "Connect your account to the tools you use.",
    "notifications": "Notifications",
    "navigation": "Account settings sections",
    "discard": "Discard changes",
    "passwordUpdated": "Password updated just now."
  },
  "referralOverview": {
    "subtitle": "Invite your network, follow your rewards, and claim what you’ve earned.",
    "heroTitle": "Good things are",
    "heroAccent": "better shared.",
    "inviteDescription": "Bring your network to {brand}. Turn your recommendations into rewards.",
    "copyLink": "Copy link",
    "linkHint": "One link for every invitation.",
    "linkUnavailable": "Referral link unavailable",
    "copied": "Referral link copied. Ready to share.",
    "copyManually": "The link is selected. Copy it using your browser or keyboard.",
    "rewardsHint": "A little thank you for spreading the word.",
    "bonusType": "Bonus type",
    "minimum": "Claims open above {amount}.",
    "submitted": "Claim submitted. Your reward is under review.",
    "shareTitle": "Share your link",
    "shareDescription": "Invite friends and colleagues using your personal referral link.",
    "earnTitle": "Earn together",
    "earnDescription": "Eligible referrals earn you traffic or money bonuses.",
    "claimTitle": "Claim your rewards",
    "claimDescription": "Submit your available bonus for review when it’s ready.",
    "history": "Bonus history",
    "historyHint": "Every reward, from pending to paid.",
    "allRewards": "All rewards",
    "filter": "Reward history filter",
    "rewardCount": "Rewards: {count}",
    "rewards": "rewards",
    "underReview": "Under review",
    "empty": "No rewards yet",
    "emptyFilter": "No rewards of this type. Try another filter.",
    "moreHistory": "More rewards are available. Load them to include them in the history and filters.",
    "confirmDescription": "Your claim will be submitted for review. The available amount will be cleared while we review your request.",
    "reviewNotice": "Submission does not mean the reward has been paid. Follow its status in your bonus history.",
    "submitClaim": "Submit claim",
    "refreshFailed": "Your claim was submitted, but the latest balances could not be loaded. Please refresh them."
  }
}
